/* DivineYug cart drawer.

   The drawer's markup is Liquid (sections/dh-cart-drawer.liquid) because /cart.js
   does not carry compare_at_price, and the whole design hangs off the saving. So
   after every change we ask Shopify to re-render that one section and swap it in.

   Nothing here depends on Horizon's cart JS. */
(function () {
  var SECTION = 'dh-cart-drawer';
  var root = document.getElementById('dhc');
  if (!root) return;

  var panel = root.querySelector('.dhc__panel');
  var busy = false;

  function open() {
    root.hidden = false;
    /* next frame, so the transition has a start state to run from */
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    var x = root.querySelector('.dhc__x');
    if (x) x.focus();
  }
  function close() {
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { if (!root.classList.contains('is-open')) root.hidden = true; }, 300);
  }

  function repaint() {
    return fetch('/?sections=' + SECTION, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('dhc');
        if (!fresh) return;
        var wasOpen = root.classList.contains('is-open');
        root.innerHTML = fresh.innerHTML;
        panel = root.querySelector('.dhc__panel');
        if (wasOpen) root.classList.add('is-open');
        bumpCount();
      });
  }

  function bumpCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.header-cart-count').forEach(function (el) {
        el.textContent = c.item_count;
      });
    });
  }

  function change(key, qty) {
    if (busy) return;
    busy = true;
    root.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(repaint)
      .catch(function () {})
      .then(function () { busy = false; root.classList.remove('is-busy'); });
  }

  function addVariant(id, qty) {
    if (busy) return Promise.resolve();
    busy = true;
    root.classList.add('is-busy');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(repaint)
      .catch(function () {})
      .then(function () { busy = false; root.classList.remove('is-busy'); });
  }

  /* ---- delegated, because the panel is replaced wholesale on every change ---- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-dh-cart-close]')) { close(); return; }

    var q = t.closest('[data-dh-qty]');
    if (q) { change(q.getAttribute('data-dh-qty'), parseInt(q.getAttribute('data-to'), 10)); return; }

    var rm = t.closest('[data-dh-remove]');
    if (rm) { change(rm.getAttribute('data-dh-remove'), 0); return; }

    /* the header cart link opens the drawer instead of navigating */
    var link = t.closest('a[href$="/cart"]');
    if (link && !t.closest('.dhc')) { e.preventDefault(); open(); repaint(); return; }
  });

  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-dh-sewa]');
    if (!s) return;
    var id = parseInt(s.getAttribute('data-dh-sewa'), 10);
    if (s.checked) { addVariant(id, 1); }
    else {
      var li = root.querySelector('.dhc__li[data-key*="' + id + '"]');
      if (li) change(li.getAttribute('data-key'), 0); else repaint();
    }
  });

  /* every add-to-cart form on the site routes through here */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.action || f.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var fd = new FormData(f);
    busy = true;
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function () { return repaint(); })
      .then(function () { open(); })
      .catch(function () { f.submit(); })
      .then(function () { busy = false; });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });
})();
